module.exports = {
      id: "astrology-usage",
      viewBox: "0 0 29.4 29.4",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#astrology",
      toString: function () {
        return this.url;
      }
    }